export default __webpack_public_path__ + "static/media/calories.37e0380e.png";